<script>
	// https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/

	export let id = null;
	export let name = null;
	export let value = null;
	export let rows = null;
	export let cols = 70;
	export let label = null;
	export let required = null;
	export let disabled = null;
	export let autoExpand = null;
	export let maxlength = null;
</script>

{#if label !== null}<label for={id} class:isrequired={required}>{label}</label>{/if}
<div class:grow_wrap={autoExpand} data-replicated-value={value}>
	<textarea {required} {disabled} {id} {name} {rows} {cols} {maxlength} bind:value on:change class="form-control"
	></textarea>
</div>

<style>
	.grow_wrap {
		display: grid;
	}

	.grow_wrap::after {
		content: attr(data-replicated-value) " ";
		white-space: pre-wrap;
		visibility: hidden;
	}

	textarea {
		resize: none;
		overflow: hidden;
	}

	textarea,
	.grow_wrap::after {
		border: 1px solid #e4e6e8;
		padding: 0.5rem;
		font-size: 14px;
		grid-area: 1 / 1 / 2 / 2;
		line-height: 1.2rem;
	}

	textarea:focus {
		border-color: #e46937;
	}
</style>
